import { graphql } from '../../graphql';

export const getKeywords = graphql(`
  query Keywords {
    keywords(filter: { path: "/" }) {
      id
      term
      url
    }
  }
`);
